import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://mecleuiqdixadskcftfm.supabase.co";
const supabaseKey = process.env.SUPABASE_KEY;
export const supabase = createClient(supabaseUrl, supabaseKey!);

export enum DB_TABLES {
  cityRequests = "city_requests",
}
